export const blockIconsPrivacyandsecurityVpnKeyAlertNew = (
	<span className='material-symbols-outlined'>vpn_key_alert</span>
);
